import React, { useEffect, useRef, useCallback, useState } from "react";
import { useLocation } from "react-router-dom";
import PropTypes from "prop-types";

// //Import Scrollbar
import SimpleBar from "simplebar-react";

// MetisMenu
import MetisMenu from "metismenujs";
import withRouter from "components/Common/withRouter";
import { Link } from "react-router-dom";

//i18n
import { withTranslation } from "react-i18next";
import configure from "configure";

const SidebarContent = (props) => {
  const ref = useRef();
  const activateParentDropdown = useCallback((item) => {
    item.classList.add("activeProjectTab");
    const parent = item.parentElement;
    const parent2El = parent.childNodes[1];

    if (parent2El && parent2El.id !== "side-menu") {
      parent2El.classList.add("mm-show");
    }

    // if (parent) {
    //   parent.classList.add("mm-active");
    //   const parent2 = parent.parentElement;

    //   if (parent2) {
    //     parent2.classList.add("mm-show"); // ul tag

    //     const parent3 = parent2.parentElement; // li tag

    //     if (parent3) {
    //       parent3.classList.add("mm-active"); // li
    //       parent3.childNodes[0].classList.add("mm-active"); //a
    //       const parent4 = parent3.parentElement; // ul
    //       if (parent4) {
    //         parent4.classList.add("mm-show"); // ul
    //         const parent5 = parent4.parentElement;
    //         if (parent5) {
    //           parent5.classList.add("mm-show"); // li
    //           parent5.childNodes[0].classList.add("mm-active"); // a tag
    //         }
    //       }
    //     }
    //   }
    //   scrollElement(item);
    //   return false;
    // }

    scrollElement(item);
    return false;
  }, []);

  const removeActivation = (items) => {
    for (var i = 0; i < items.length; ++i) {
      var item = items[i];
      const parent = items[i].parentElement;

      if (item && item.classList.contains("activeProjectTab")) {
        item.classList.remove("activeProjectTab");
      }
      if (parent) {
        const parent2El =
          parent.childNodes && parent.childNodes.lenght && parent.childNodes[1]
            ? parent.childNodes[1]
            : null;
        if (parent2El && parent2El.id !== "side-menu") {
          parent2El.classList.remove("mm-show");
        }

        parent.classList.remove("mm-active");
        const parent2 = parent.parentElement;

        if (parent2) {
          parent2.classList.remove("mm-show");

          const parent3 = parent2.parentElement;
          if (parent3) {
            parent3.classList.remove("mm-active"); // li
            parent3.childNodes[0].classList.remove("mm-active");

            const parent4 = parent3.parentElement; // ul
            if (parent4) {
              parent4.classList.remove("mm-show"); // ul
              const parent5 = parent4.parentElement;
              if (parent5) {
                parent5.classList.remove("mm-show"); // li
                parent5.childNodes[0].classList.remove("mm-active"); // a tag
              }
            }
          }
        }
      }
    }
  };

  const path = useLocation();

  const activeMenu = useCallback(() => {
    const pathName = path.pathname;
    let matchingMenuItem = null;
    const ul = document.getElementById("side-menu");
    const items = ul.getElementsByTagName("a");
    removeActivation(items);

    for (let i = 0; i < items.length; ++i) {
      if (pathName === items[i].pathname) {
        matchingMenuItem = items[i];
        break;
      }
    }
    if (matchingMenuItem) {
      activateParentDropdown(matchingMenuItem);
    }
  }, [path.pathname, activateParentDropdown]);

  useEffect(() => {
    ref.current.recalculate();
  }, []);

  useEffect(() => {
    new MetisMenu("#side-menu");
    activeMenu();
  }, []);

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "smooth" });
    activeMenu();
  }, [activeMenu]);

  function scrollElement(item) {
    if (item) {
      const currentPosition = item.offsetTop;
      if (currentPosition > window.innerHeight) {
        ref.current.getScrollElement().scrollTop = currentPosition - 300;
      }
    }
  }

  const [active, setActive] = useState(false);

  return (
    <React.Fragment>
      <SimpleBar className="h-100" ref={ref}>
        <div id="sidebar-menu">
          <ul className="metismenu list-unstyled" id="side-menu">
            <li className="menu-title">{props.t("Menu")} </li>

            {/* <li>
            <Link to="/#" className="">
              <i className="bx bx-home-circle"></i>
              <span>{props.t("Dashboards")}</span>
            </Link>

            <ul className="sub-menu">
              <li>
                <Link to="/dashboard">{props.t("Default")}</Link>
              </li>
              <li>
                <Link to="#">{props.t("Saas")}</Link>
              </li>
              <li>
                <Link to="#">{props.t("Crypto")}</Link>
              </li>
              <li>
                <Link to="#">{props.t("Blog")}</Link>
              </li>
              <li>
                <Link to="#">
                  <span className="badge rounded-pill text-bg-success float-end" key="t-new">New</span>
                  {props.t("Jobs")}
                </Link>
              </li>
            </ul>

          </li> */}

            <li>
              <Link to={`${configure.appUrl}/dashboard`} className="">
                <i className="bx bx-home-circle"></i>
                <span>{props.t("Dashboard")}</span>
              </Link>
            </li>
            {/* <li className="menu-title">{props.t("Apps")}</li> */}

            <li>
              <Link to={`${configure.appUrl}/lead-section`} className="">
                <i className="bx bx-list-check "></i>
                <span>{props.t("Lead")}</span>
              </Link>
            </li>

            {/* <li>
            <Link to="#" >
              <i className="bx bx-chat"></i>
              <span>{props.t("Chat")}</span>
            </Link>
          </li> */}

            <li>
              <Link to={`${configure.appUrl}/customer-section`}>
                <i className="fas fa-users"></i>
                <span>{props.t("Customer")}</span>
              </Link>
            </li>
            <li>
              <Link to={`${configure.appUrl}/proposal-section`}>
                <i className="bx bx-spreadsheet"></i>
                <span>{props.t("Proposal")}</span>
              </Link>
            </li>

            <li>
              <Link to={`${configure.appUrl}/contract-section`}>
                <i className="bx bx-book-content"></i>
                <span>{props.t("Contract")}</span>
              </Link>
            </li>

            <li>
              <Link to={`${configure.appUrl}/project-section`}>
                <i className="bx bx-book"></i>
                <span>{props.t("Project")}</span>
              </Link>
            </li>

            {/* <li>
            <Link to={`${configure.appUrl}/hosting-section`} >
              <i className="bx bx-server"></i>
              <span>{props.t("Hosting")}</span>
            </Link>
          </li> */}

            <li>
              <Link to="/#" className="has-arrow ">
                <i className="bx bx-dollar-circle"></i>
                <span>{props.t("Invoice")}</span>
              </Link>
              <ul className="sub-menu">
                <li>
                  <Link to={`${configure.appUrl}/zithas-invoice`}>
                    {props.t("Zithas Technologies")}
                  </Link>
                </li>
                <li>
                  <Link to={`${configure.appUrl}/ztpl-invoice`}>
                    {props.t("Zithas")}
                  </Link>
                </li>
              </ul>
            </li>

            <li>
              <Link to={`${configure.appUrl}/finance-section`} >
                <i className="bx bx-user-circle"></i>
                <span>{props.t("Finance")}</span>
              </Link>
            </li>

            <li>
              <Link to={`${configure.appUrl}/support-section`} className="">
                <i className="bx bx-phone-outgoing"></i>
                <span>{props.t("Support")}</span>
              </Link>
            </li>
            <li>
              <Link to={`${configure.appUrl}/calendar`} className="">
                <i className="bx bx-calendar-event"></i>
                <span>{props.t("Calendar")}</span>
              </Link>
            </li>

            <li>
              <Link to={`${configure.appUrl}/logout`}>
                <i className="bx bx-power-off text-danger"></i>
                <span>{props.t("Log Out")}</span>
              </Link>
            </li>
          </ul>
        </div>
      </SimpleBar>
    </React.Fragment>
  );
};

SidebarContent.propTypes = {
  location: PropTypes.object,
  t: PropTypes.any,
};

export default withRouter(withTranslation()(SidebarContent));
